import BrazeService from './BrazeService';

class InAppMessagingService {
  subscribe() {
    BrazeService.subscribeToInAppMessage();
  }
}

export default new InAppMessagingService();
